import React from 'react';
import { Row, Col } from 'antd';
import { useI18n } from 'hooks/useI18n';
import TableComponent from 'components/table-component';
import { SMSPageShell, SMSPanel } from '../shared';

const SMSPricing = () => {
	const { t } = useI18n();
	const columns = [
		{
			title: t('sms.pricing.columns.sno'),
			dataIndex: 'sno',
			key: 'sno',
		},
		{
			title: t('sms.pricing.columns.quantity'),
			dataIndex: 'quantity',
			key: 'quantity',
		},
		{
			title: t('sms.pricing.columns.validity'),
			dataIndex: 'validity',
			key: 'validity',
		},
		{
			title: t('sms.pricing.columns.price'),
			dataIndex: 'price',
			key: 'price',
		},
		{
			title: t('sms.pricing.columns.total_with_tax'),
			dataIndex: 'totalWithTax',
			key: 'totalWithTax',
		},
	];

	const data = [
		{
			key: '1',
			sno: '1',
			quantity: '10k',
			validity: '5 years',
			price: '₹ 2000',
			totalWithTax: '₹ 2360',
		},
		{
			key: '2',
			sno: '2',
			quantity: '25k',
			validity: '5 years',
			price: '₹ 5000',
			totalWithTax: '₹ 5900',
		},
		{
			key: '3',
			sno: '3',
			quantity: '50k',
			validity: '5 years',
			price: '₹ 10000',
			totalWithTax: '₹ 11800',
		},
		{
			key: '4',
			sno: '4',
			quantity: '1L',
			validity: '5 years',
			price: '₹ 20000',
			totalWithTax: '₹ 23600',
		},
	];

	return (
		<SMSPageShell
			eyebrow={t('navigation.sms')}
			title={t('sms.pricing.title')}
			subtitle={t('sms.pricing.subtitle')}
			creditLabel={t('sms.pricing.hero_label')}
			creditCount={50000}
			meta={[
				{ label: t('sms.pricing.metrics.best_value'), value: t('sms.pricing.metrics.best_value_pack'), helper: t('sms.pricing.metrics.best_value_helper') },
				{ label: t('sms.pricing.metrics.validity'), value: t('sms.pricing.metrics.validity_value'), helper: t('sms.pricing.metrics.validity_helper') },
				{ label: t('sms.pricing.metrics.tax'), value: '18%', helper: t('sms.pricing.metrics.tax_helper') },
			]}
		>
			<Row gutter={[16, 16]}>
				<Col span={24}>
					<SMSPanel title={t('sms.pricing.table_title')} subtitle={t('sms.pricing.table_subtitle')}>
						<TableComponent columns={columns} dataSource={data} pagination={false} rowKey="key" />
					</SMSPanel>
				</Col>
			</Row>
		</SMSPageShell>
	);
};

export default SMSPricing;
